<template>
    <form-row title="Is This a Commercial or Residential Property?" :label_align_top="true">
        <div class="flex flex-col flex-1 pt-2">
            <input-radio-boolean
                name="is_commercial"
                v-model="is_commercial"
                true="Commercial"
                false="Residential"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        property: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            is_commercial: this.property.is_commercial ? true : false,
        }
    },
}
</script>
